export default __webpack_public_path__ + "static/media/down.22df19f9.svg";